import {
  dateFormat,
  formatDateAndTime,
} from 'helpers/StringNumberFunction/formatDate';
import { moneyFunction } from 'helpers/StringNumberFunction/moneyFunction';
import { amtStr } from 'helpers/StringNumberFunction/numFormatter';
import { renderToStaticMarkup } from 'react-dom/server';
import QRCode from 'react-qr-code';
import React from 'react';

const generateQRCodeSVG = value => {
  const qrCodeElement = (
    <QRCode
      size={128}
      style={{ height: '75px', width: '75px' }}
      value={value}
      // viewBox={`0 0 128 128`}
    />
  );
  return renderToStaticMarkup(qrCodeElement);
};

export const ELetterServiceClient = ({
  docType,
  previewDetail,
  allpreviewDetail,
  getCompany,
  getSubcontract,
  getCustomer,
  paramVal,
  ItemIndex,
  approvalLog,
}) => {
  const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));

  let approverNameL1 = '';
  let approvalDateL1 = '';
  let roleNameL1 = '';
  let approverNameL2 = '';
  let approvalDateL2 = '';
  let roleNameL2 = '';
  let approverNameL3 = '';
  let approvalDateL3 = '';
  let roleNameL3 = '';
  let approverNameL4 = '';
  let approvalDateL4 = '';
  let roleNameL4 = '';
  let approverNameL5 = '';
  let approvalDateL5 = '';
  let roleNameL5 = '';

  if (approvalLog && approvalLog.length > 0) {
    const completedWorkflow = approvalLog.find(
      wf => wf.workFlowStatus === 'COMPLETED',
    );

    if (completedWorkflow?.workflowStep) {
      // Filter only approved steps and sort by stepNo
      const approvedSteps = completedWorkflow.workflowStep
        .filter(step => step.approvalStatus === 'APPROVED')
        .sort((a, b) => a.stepNo - b.stepNo);

      approvedSteps.forEach(step => {
        if (step.stepNo === 1) {
          approverNameL1 = step.name || '';
          approvalDateL1 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL1 = step.roleName || '';
        } else if (step.stepNo === 2) {
          approverNameL2 = step.name || '';
          approvalDateL2 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL2 = step.roleName || '';
        } else if (step.stepNo === 3) {
          approverNameL3 = step.name || '';
          approvalDateL3 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL3 = step.roleName || '';
        } else if (step.stepNo === 4) {
          approverNameL4 = step.name || '';
          approvalDateL4 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL4 = step.roleName || '';
        } else if (step.stepNo === 5) {
          approverNameL5 = step.name || '';
          approvalDateL5 = step.approvalDT ? dateFormat(step.approvalDT) : '';
          roleNameL5 = step.roleName || '';
        }
      });
    }
  }

  const contact = Array.isArray(previewDetail?.contract?.contact)
    ? previewDetail?.contract?.contact[0]
    : previewDetail?.contract?.contact;

  const bankAddress =
    previewDetail?.contract?.bankAccount?.bankProfile?.address;

  const debtorDetails = {
    // ==========================
    // COMPANY / CLIENT DETAILS
    // ==========================
    '[clientName]': previewDetail?.customer?.name ?? '',
    '[clientEmail]': previewDetail?.customer?.email ?? '',
    '[clientContactNo]':
      previewDetail?.contact?.contactNo ??
      previewDetail?.contract?.contact?.[0]?.contactNo ??
      previewDetail?.customer?.contactPerson?.[0]?.contactNo ??
      '',
    '[contactPerson]':
      previewDetail?.contact?.name ??
      previewDetail?.contract?.contact?.[0]?.name ??
      previewDetail?.customer?.contactPerson?.[0]?.name ??
      '',
    '[companyMsicCode]': companyDetails?.msicCode ?? '',

    // ==========================
    // CLIENT ADDRESS
    // ==========================
    '[clientAddress]': `${previewDetail?.customer?.address?.address}<br />
    ${
      previewDetail?.customer?.address?.country === 'Singapore'
        ? `${previewDetail?.customer?.address?.country} ${previewDetail?.customer?.address?.postCode}`
        : `${previewDetail?.customer?.address?.postCode} ${previewDetail?.customer?.address?.city}, 
          ${previewDetail?.customer?.address?.state}, ${previewDetail?.customer?.address?.country}`
    }<br />`,

    // ==========================
    // CLIENT BANK DETAILS
    // ==========================
    '[clientBankAccName]': previewDetail?.customer?.BankName ?? '',
    '[clientBankAccNo]': previewDetail?.customer?.BankAccountNo ?? '',

    // ==========================
    // CLIENT REGISTRATION NUMBERS
    // ==========================
    '[clientCompanyRegNo]': previewDetail?.customer?.registrationNo ?? '',
    '[clientTIN]': previewDetail?.customer?.tinNo ?? '',
    '[clientRegNo]':
      previewDetail?.customer?.gstRegNo ??
      previewDetail?.customer?.registrationNo ??
      '',
    '[clientSstNo]': previewDetail?.customer?.sstRegNo ?? '',
    // '[companySSTRegNo]': previewDetail?.SSTRegNo ?? '',
    '[companySSTRegNo]': previewDetail?.SSTRegNo ?? companyDetails?.sstNo ?? '',

    // ==========================
    // DOCUMENT DETAILS
    // ==========================
    '[docNo]': previewDetail?.docNo ?? '',
    '[docRef]': previewDetail?.docRef ?? '',
    '[referenceNo]': previewDetail?.docRef ?? '',
    '[docDate]': dateFormat(previewDetail?.docDate) ?? '',
    '[description]': previewDetail?.description ?? '',

    // ==========================
    // CONTRACT DETAILS
    // ==========================
    '[contractTitle]':
      previewDetail?.contract?.pdfDocumentTitle ??
      previewDetail?.contract?.title ??
      '',
    '[creditTerm]': previewDetail?.contract?.creditTerm ?? 0,
    '[contractAddress]': `${getSubcontract[0]?.site?.address?.address}, ${getSubcontract[0]?.site?.address?.city} ${getSubcontract[0]?.site?.address?.postCode}`,
    '[contractDate]': previewDetail?.contract?.contractDate ?? '',

    // ==========================
    // BANK DETAILS
    // ==========================
    '[bankName]': previewDetail?.contract?.bankAccount?.bankProfile?.name ?? '',
    '[bankAddress]': `${bankAddress?.address}, ${bankAddress?.city}, 
          ${bankAddress?.state}, ${bankAddress?.country}, ${bankAddress?.postCode}`,
    '[bankAccountNo]': previewDetail?.contract?.bankAccount?.accountNo ?? '',
    '[bankSwiftCode]': previewDetail?.contract?.bankAccount?.swiftCode ?? '',
    // ==========================
    // E-INVOICE PARAMETERS
    // ==========================
    '[qrCode]':
      previewDetail?.isEInvoice && previewDetail?.eInvoiceQrUrl
        ? generateQRCodeSVG(previewDetail?.eInvoiceQrUrl)
        : '',
    '[EInvoiceValidatedDate]': previewDetail?.einvoice_validation_date
      ? formatDateAndTime(previewDetail?.einvoice_validation_date)
      : '',
    '[EInvoiceSentDate]': previewDetail?.einvoice_sent_date
      ? formatDateAndTime(previewDetail?.einvoice_sent_date)
      : '',
    '[EInvoiceStatus]': previewDetail?.einvoice_status ?? '',
    '[uniqueIdentifierNo]': previewDetail?.eInvoiceIrbmUniqueID ?? '',
    '[approverNameL1]': approverNameL1,
    '[approvalDateL1]': approvalDateL1,
    '[roleNameL1]': roleNameL1,
    '[approverNameL2]': approverNameL2,
    '[approvalDateL2]': approvalDateL2,
    '[roleNameL2]': roleNameL2,
    '[approverNameL3]': approverNameL3,
    '[approvalDateL3]': approvalDateL3,
    '[roleNameL3]': roleNameL3,
    '[approverNameL4]': approverNameL4,
    '[approvalDateL4]': approvalDateL4,
    '[roleNameL4]': roleNameL4,
    '[approverNameL5]': approverNameL5,
    '[approvalDateL5]': approvalDateL5,
    '[roleNameL5]': roleNameL5,
  };
  /* -------------------------------------------------
   * 1 and 2.  ADVANCES & OFFICIAL RECEIPT
   * -------------------------------------------------*/
  switch (docType) {
    case 'advances':
    case 'official-receipt': {
      Object.assign(paramVal, debtorDetails, {
        // ==========================
        // DOCUMENT DESCRIPTION
        // ==========================
        '[remark]': previewDetail?.remark ?? '',
        '[description]': previewDetail?.description ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        // ==========================
        // BANK & PAYMENT DETAILS
        // ==========================
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ==========================
        // AMOUNT DETAILS
        // ==========================
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',
        '[itemTotalAmt]': amtStr(previewDetail?.docAmt) ?? '',

        // ==========================
        // CURRENCY DETAILS
        // ==========================
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
      });
      break;
    }

    /* -------------------------------------------------
     * 3.  REFUND DOCUMENT
     * -------------------------------------------------*/
    case 'refund': {
      Object.assign(paramVal, debtorDetails, {
        /* ────────────────
         * BASIC INFO
         * ────────────────*/
        '[remark]': previewDetail?.remark ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        /* ────────────────
         * BANK / PAYMENT
         * ────────────────*/
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        /* ────────────────
         * ALLOCATION ITEMS (TABLE)
         * ────────────────*/
        items: (previewDetail?.allocation ?? []).map(el => ({
          '[allocationDate]': dateFormat(el?.docDate) ?? '',
          '[allocationNo]': el?.docNo ?? '',
          '[allocationDesc]': el?.description ?? '',
          '[allocationAmt]': amtStr(el?.allocatedByDoc ?? 0),
        })),

        /* ────────────────
         * AMOUNTS
         * ────────────────*/
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',
        '[itemTotalAmt]': amtStr(previewDetail?.docAmt) ?? '',

        /* ────────────────
         * CURRENCY
         * ────────────────*/
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
      });
      break;
    }

    /* -------------------------------------------------
     * 4.  MISCELLANEOUS INVOICE
     * -------------------------------------------------*/
    case 'misc-invoice': {
      /* Helper calculations */
      const totalPrincipalAmt =
        previewDetail?.contractMiscInvoiceItem?.reduce(
          (sum, item) =>
            sum + (Number(item?.docAmt) - Number(item?.taxAmt || 0)),
          0,
        ) ?? 0;

      const totalTaxAmt =
        previewDetail?.contractMiscInvoiceItem?.reduce(
          (sum, item) => sum + Number(item?.taxAmt || 0),
          0,
        ) ?? 0;

      const docAmt = totalPrincipalAmt + totalTaxAmt; // grand total
      const totalAmtInWords = moneyFunction(docAmt);

      Object.assign(paramVal, debtorDetails, {
        /* ────────────────
         * BENEFICIARY
         * ────────────────*/
        '[beneficiaryNo]':
          previewDetail?.contract?.bankAccount?.accountNo ?? '',
        '[beneficiaryBankName]':
          previewDetail?.contract?.bankAccount?.name ?? '',

        /* ────────────────
         * CONTACT
         * ────────────────*/
        '[invoiceContractTitle]': previewDetail?.contract?.title ?? '',
        '[invoiceContactNo]':
          previewDetail?.customer?.contactPerson?.[0]?.contactNo ?? '',
        '[invoiceContactName]':
          previewDetail?.customer?.contactPerson?.[0]?.name ?? '',

        /* ────────────────
         * LINE‑ITEMS
         * ────────────────*/
        items: (previewDetail?.contractMiscInvoiceItem ?? []).map(item => {
          const principal = Number(item?.docAmt) - Number(item?.taxAmt || 0);
          const rate = Number(item?.taxRate || 0);
          const tax = principal * (rate / 100);
          const total = principal + tax;

          ///////////////////////////////
          /////// SST EHANCEMENT ///////
          //////////////////////////////

          const formatTaxExemption = (taxScheme, principalAmt) => {
            if (!taxScheme || !taxScheme.isExclusive) return '';

            const description = taxScheme?.description || '';
            const rate = parseFloat(item?.taxAmt || 0) / 100;
            const exemptedAmount = rate * principalAmt;

            return `${description} (${amtStr(exemptedAmount.toFixed(2))})`;
          };

          const withB2BNote = (value: string) => {
            if (!value || value.trim() === '') return '';
            return `<br><span style="font-size:9pt;color:#666;font-style:italic;">*B2B Exemption</span> ${value}`;
          };

          let miscTaxExemp = '';
          let miscTotalTaxExemptedAmt = 0;

          const taxSchemeData = item?.taxScheme;

          if (!!taxSchemeData?.isExclusive) {
            // total = itemPrincipalAmt
            miscTaxExemp = formatTaxExemption(taxSchemeData, total);

            miscTotalTaxExemptedAmt =
              previewDetail?.contractMiscInvoiceItem?.reduce(
                (sum, item) => sum + rate * total,
                0,
              ) ?? 0;
          }

          return {
            '[itemDescription]': item?.revenueCategory?.name ?? '',
            '[classification]':
              item?.classificationCode?.classificationCode ?? '',
            '[principalAmt]': amtStr(principal),
            '[taxRate]': `${amtStr(rate)}%`,
            '[itemTaxAmt]': amtStr(tax),
            '[itemPrincipalAmt]': amtStr(total),
            /* ────────────────
             * SST ENHANCEMENT
             * ────────────────*/
            '[miscTaxExemp]': withB2BNote(miscTaxExemp),
            '[miscTotalTaxExemptedAmt]': miscTotalTaxExemptedAmt,
            '[miscTotalTaxAmt]': amtStr(totalTaxAmt.toFixed(2)),
            '[dateandTimeofValidation]': previewDetail?.eInvoiceValidationDate
              ? formatDateAndTime(previewDetail?.eInvoiceInfo?.submittedDate)
              : '',
          };
        }),

        /* ────────────────
         * TOTALS
         * ────────────────*/
        '[totalPrincipalAmt]': amtStr(totalPrincipalAmt.toFixed(2)),
        '[totalTaxAmt]': amtStr(totalTaxAmt.toFixed(2)),
        '[docAmt]': amtStr(docAmt.toFixed(2)),

        /* ────────────────
         * CURRENCY
         * ────────────────*/
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[totalAmtInWords]': totalAmtInWords,
      });
      break;
    }

    /* -------------------------------------------------
     * 5. CREDIT NOTE
     * -------------------------------------------------*/
    case 'credit-note': {
      const principalTotal =
        previewDetail?.contractCNItem?.reduce(
          (sum, item) =>
            sum + (Number(item?.docAmt) - Number(item?.taxAmt || 0)),
          0,
        ) ?? 0;

      const taxTotal =
        previewDetail?.contractCNItem?.reduce(
          (sum, item) => sum + Number(item?.taxAmt || 0),
          0,
        ) ?? 0;

      const total = principalTotal + taxTotal;

      Object.assign(paramVal, debtorDetails, {
        /* ────────────────
         * LINE ITEMS
         * ────────────────*/
        items: (previewDetail?.contractCNItem ?? []).map(item => {
          const principal = Number(item?.docAmt) - Number(item?.taxAmt || 0);
          const rate = Number(item?.taxRate || 0);
          const tax = principal * (rate / 100);
          const currentTax = Number(item?.taxAmt || 0);
          const totalItem = principal + currentTax;

          const totalTaxAmt =
            previewDetail?.contractCNItem?.reduce(
              (sum, item) => sum + Number(item?.taxAmt || 0),
              0,
            ) ?? 0;

          ///////////////////////////////
          /////// SST EHANCEMENT ///////
          //////////////////////////////

          const formatTaxExemption = (taxScheme, principalAmt) => {
            if (!taxScheme || !taxScheme.isExclusive) return '';

            const description = taxScheme?.description || '';
            const rate = parseFloat(item?.taxAmt || 0) / 100;
            const exemptedAmount = rate * principalAmt;

            return `${description} (${amtStr(exemptedAmount.toFixed(2))})`;
          };

          const withB2BNote = (value: string) => {
            if (!value || value.trim() === '') return '';
            return `<br><span style="font-size:9pt;color:#666;font-style:italic;">*B2B Exemption</span> ${value}`;
          };

          let cnTaxExemp = '';
          let cnTotalTaxExemptedAmt = 0;

          const taxSchemeData = item?.taxScheme;

          if (!!taxSchemeData?.isExclusive) {
            // total = itemPrincipalAmt
            cnTaxExemp = formatTaxExemption(taxSchemeData, total);

            cnTotalTaxExemptedAmt =
              previewDetail?.contractCNItem?.reduce(
                (sum, item) => sum + rate * total,
                0,
              ) ?? 0;
          }

          return {
            '[itemDescription]': item?.revenueCategory?.name ?? '',
            '[classification]':
              item?.classificationCode?.classificationCode ?? '',
            '[principalAmt]': amtStr(principal),
            '[taxRate]': `${amtStr(rate)}%`,
            '[itemTaxAmt]': amtStr(currentTax),
            '[itemPrincipalAmt]': amtStr(totalItem),
            /* ────────────────
             * SST ENHANCEMENT
             * ────────────────*/
            '[cnTaxExemp]': withB2BNote(cnTaxExemp),
            '[cnTotalTaxExemptedAmt]': cnTotalTaxExemptedAmt,
            '[cnTotalTaxAmt]': amtStr(totalTaxAmt.toFixed(2)),
            '[dateandTimeofValidation]': previewDetail?.eInvoiceValidationDate
              ? formatDateAndTime(previewDetail?.eInvoiceInfo?.submittedDate)
              : '',
          };
        }),

        /* ────────────────
         * CURRENCY
         * ────────────────*/
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',

        /* ────────────────
         * TOTALS
         * ────────────────*/
        '[totalAmtInWords]': moneyFunction(total),
        '[totalPrincipalAmt]': amtStr(principalTotal.toFixed(2)),
        '[totalTaxAmt]': amtStr(taxTotal.toFixed(2)),
        '[docAmt]': amtStr(total.toFixed(2)),
      });

      break;
    }

    /* -------------------------------------------------
     * 6. DEBIT NOTE
     * -------------------------------------------------*/
    case 'debit-note': {
      const principalTotal =
        previewDetail?.contractDNItem?.reduce(
          (sum, item) =>
            sum + (Number(item?.docAmt) - Number(item?.taxAmt || 0)),
          0,
        ) ?? 0;

      const taxTotal =
        previewDetail?.contractDNItem?.reduce(
          (sum, item) => sum + Number(item?.taxAmt || 0),
          0,
        ) ?? 0;

      const total = principalTotal + taxTotal;

      Object.assign(paramVal, debtorDetails, {
        /* ────────────────
         * LINE ITEMS
         * ────────────────*/
        items: (previewDetail?.contractDNItem ?? []).map(item => {
          const principal = Number(item?.docAmt) - Number(item?.taxAmt || 0);
          const rate = Number(item?.taxRate || 0);
          const tax = principal * (rate / 100);
          const totalItem = principal + tax;

          const totalTaxAmt =
            previewDetail?.contractDNItem?.reduce(
              (sum, item) => sum + Number(item?.taxAmt || 0),
              0,
            ) ?? 0;

          ///////////////////////////////
          /////// SST EHANCEMENT ///////
          //////////////////////////////

          const formatTaxExemption = (taxScheme, principalAmt) => {
            if (!taxScheme || !taxScheme.isExclusive) return '';

            const description = taxScheme?.description || '';
            const rate = parseFloat(item?.taxAmt || 0) / 100;
            const exemptedAmount = rate * principalAmt;

            return `${description} (${amtStr(exemptedAmount.toFixed(2))})`;
          };

          const withB2BNote = (value: string) => {
            if (!value || value.trim() === '') return '';
            return `<br><span style="font-size:9pt;color:#666;font-style:italic;">*B2B Exemption</span> ${value}`;
          };

          let dnTaxExemp = '';
          let dnTotalTaxExemptedAmt = 0;

          const taxSchemeData = item?.taxScheme;

          if (!!taxSchemeData?.isExclusive) {
            // total = itemPrincipalAmt
            dnTaxExemp = formatTaxExemption(taxSchemeData, total);

            dnTotalTaxExemptedAmt =
              previewDetail?.contractDNItem?.reduce(
                (sum, item) => sum + rate * total,
                0,
              ) ?? 0;
          }

          return {
            '[itemDescription]': item?.revenueCategory?.name ?? '',
            '[classification]':
              item?.classificationCode?.classificationCode ?? '',
            '[principalAmt]': amtStr(principal),
            '[taxRate]': `${amtStr(rate)}%`,
            '[itemTaxAmt]': amtStr(tax),
            '[itemPrincipalAmt]': amtStr(totalItem),
            /* ────────────────
             * SST ENHANCEMENT
             * ────────────────*/
            '[dnTaxExemp]': withB2BNote(dnTaxExemp),
            '[dnTotalTaxExemptedAmt]': dnTotalTaxExemptedAmt,
            '[dnTotalTaxAmt]': amtStr(totalTaxAmt.toFixed(2)),
            '[dateandTimeofValidation]': previewDetail?.eInvoiceValidationDate
              ? formatDateAndTime(previewDetail?.eInvoiceInfo?.submittedDate)
              : '',
          };
        }),

        /* ────────────────
         * CURRENCY
         * ────────────────*/
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',

        /* ────────────────
         * TOTALS
         * ────────────────*/
        '[totalAmtInWords]': moneyFunction(total),
        '[totalPrincipalAmt]': amtStr(principalTotal.toFixed(2)),
        '[totalTaxAmt]': amtStr(taxTotal.toFixed(2)),
        '[docAmt]': amtStr(total.toFixed(2)),
      });

      break;
    }

    /* -------------------------------------------------
     * 7. RETENTION CLAIMS
     * -------------------------------------------------*/
    case 'retention-claims': {
      Object.assign(paramVal, debtorDetails, {
        // ───── BASIC DETAILS ─────
        '[remark]': previewDetail?.remark ?? '',
        '[description]': previewDetail?.description ?? '',
        '[claimDocNo]': previewDetail?.claimDocNo ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        // ───── BANK / PAYMENT ─────
        '[beneficiaryNo]':
          previewDetail?.contract?.bankAccount?.accountNo ?? '',
        '[beneficiaryBankName]':
          previewDetail?.contract?.bankAccount?.name ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ───── AMOUNTS ─────
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',
        '[itemTotalAmt]': amtStr(previewDetail?.docAmt) ?? '',

        // ───── CURRENCY ─────
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[totalAmtInWords]': moneyFunction(previewDetail?.docAmt),
      });
      break;
    }

    /* -------------------------------------------------
     * 8. CLAIM SUMMARY
     * -------------------------------------------------*/
    case 'claim-summary': {
      const submittedCurrentCertifiedAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentCertifiedAmt
          : previewDetail?.submittedCertifiedAmt || '0',
      );
      const submittedcurrentVOClaimAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.submittedVOClaimAmt
          : previewDetail?.currentVOClaimAmt || '0',
      );
      const submittedCurrentMosAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentMosAmt
          : previewDetail?.submittedMosAmt || '0',
      );
      const retentionAmt = parseFloat(previewDetail?.retentionAmt || '0');
      const previousCertifiedAmt = parseFloat(
        previewDetail?.previousCertifiedAmt || '0',
      );
      const currentDayWorkAmt = parseFloat(
        previewDetail?.currentDayWorkAmt || '0',
      );
      const taxAmt = parseFloat(previewDetail?.taxAmt || '0');

      const totalAmountDue =
        submittedCurrentCertifiedAmt +
        submittedcurrentVOClaimAmt +
        submittedCurrentMosAmt -
        retentionAmt -
        previousCertifiedAmt +
        currentDayWorkAmt;
      const itemTotalAmt = totalAmountDue + taxAmt;

      Object.assign(paramVal, debtorDetails, {
        // ───── BASIC DETAILS ─────
        '[remark]': previewDetail?.remark ?? '',
        '[description]': previewDetail?.description ?? '',
        '[claimDocNo]': previewDetail?.claimDocNo ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        // ───── BANK / PAYMENT ─────
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ───── AMOUNTS ─────
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',

        '[totalAmountDue]': amtStr(totalAmountDue.toString()) ?? '',
        '[itemTotalAmt]': amtStr(itemTotalAmt.toString()) ?? '',
        '[totalAmtInWords]': moneyFunction(itemTotalAmt.toString()),

        // ───── CONTRACT INFO ─────
        '[contractNo]': previewDetail?.contract?.contractNo ?? '',
        '[contractSum]': amtStr(previewDetail?.contract?.contractSum),
        '[voAmount]': amtStr(previewDetail?.voDisplayAmt),
        '[revisedContractSum]': amtStr(
          previewDetail?.contract?.revisedContractSum,
        ),
        '[maxRetentionSum]': amtStr(previewDetail?.contract?.maxRetentionSum),

        // ───── DATES ─────
        '[docDate]': dateFormat(previewDetail?.contract?.startDate),
        '[docDueDate]': dateFormat(previewDetail?.contract?.endDate),
        '[submissionDate]': dateFormat(previewDetail?.submittedDate),
        '[approvalDate]': dateFormat(previewDetail?.docDate),

        // ───── REFERENCE DETAILS ─────
        '[docRefNo]': previewDetail?.docRef ?? '',
        '[docNo]': previewDetail?.docNo ?? '',
        '[claimNo]': previewDetail?.claimDocNo ?? '',
        '[clientContact]':
          previewDetail?.customer?.contactPerson[0]?.contactNo ?? '',

        // ───── CLAIM COMPONENTS ─────
        '[currentApprovalAmt]': amtStr(
          previewDetail?.transactionStatus === 'APPROVED'
            ? previewDetail?.currentCertifiedAmt
            : previewDetail?.submittedCertifiedAmt,
        ),
        '[voClaimAmt]': amtStr(
          previewDetail?.transactionStatus === 'APPROVED'
            ? previewDetail?.submittedVOClaimAmt
            : previewDetail?.currentVOClaimAmt,
        ),
        '[totalClaimApprovalAmt]':
          amtStr(
            (
              submittedCurrentCertifiedAmt + submittedcurrentVOClaimAmt
            ).toString(),
          ) ?? '',

        '[currentMosAmt]': amtStr(previewDetail?.submittedMosAmt),
        '[previousMosAmt]': amtStr(previewDetail?.previousMosAmt),
        '[submittedMosAmt]': amtStr(previewDetail?.submittedMosAmt),

        '[retentionAmt]': amtStr(previewDetail?.retentionAmt),
        '[previousCertifiedAmt]': amtStr(previewDetail?.previousCertifiedAmt),
        '[previousVOClaimAmt]': amtStr(previewDetail?.previousVOClaimAmt),

        '[dayworksAmt]': amtStr(previewDetail?.currentDayWorkAmt),
        '[subtotalAmt]':
          amtStr(
            (
              submittedCurrentCertifiedAmt +
              submittedcurrentVOClaimAmt +
              submittedCurrentMosAmt -
              retentionAmt
            ).toString(),
          ) ?? '',
        '[currentDeductionAmt]': amtStr(previewDetail?.currentDeductionAmt),
        '[advanceRecoupmentAmt]': amtStr(previewDetail?.advanceRecoupmentAmt),

        // ───── NOTES ─────
        '[noteText]': previewDetail?.noteText ?? '',

        // ───── CURRENCY ─────
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
      });
      break;
    }

    case 'claim-invoice': {
      const certifiedAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentCertifiedAmt
          : previewDetail?.submittedCertifiedAmt || '0',
      );
      const submittedVOAmt = parseFloat(
        previewDetail?.transactionStatus === 'APPROVED'
          ? previewDetail?.currentVOClaimAmt
          : previewDetail?.submittedVOClaimAmt || '0',
      );
      const previousCertifiedAmt = parseFloat(
        previewDetail?.previousCertifiedAmt || '0',
      );
      const previousVOAmt = parseFloat(
        previewDetail?.previousVOClaimAmt || '0',
      );
      const previousMosAmt = parseFloat(previewDetail?.previousMosAmt || '0');
      const submittedMosAmt = parseFloat(previewDetail?.submittedMosAmt || '0');
      const submittedDayworkAmt = parseFloat(
        previewDetail?.submittedDayWorkAmt || '0',
      );
      const retentionAmt = parseFloat(previewDetail?.retentionAmt || '0');

      const taxAmt = parseFloat(previewDetail?.taxAmt || '0');

      const totalClaimAmt =
        certifiedAmt +
        submittedVOAmt -
        previousCertifiedAmt +
        submittedMosAmt +
        submittedDayworkAmt;
      const totalPayableAmt = totalClaimAmt - retentionAmt;
      const progressBillingToDate =
        certifiedAmt + submittedVOAmt - previousCertifiedAmt;

      const totalBaseAmt =
        certifiedAmt +
        submittedVOAmt +
        submittedMosAmt -
        previousCertifiedAmt -
        previousVOAmt -
        previousMosAmt -
        retentionAmt;

      const itemTotalAmt = totalBaseAmt + taxAmt;
      const sumOfClaim = itemTotalAmt + retentionAmt;

      const currentDayWorkAmt = parseFloat(
        previewDetail?.currentDayWorkAmt || '0',
      );

      // ============================================================
      // SST ENHANCEMENT - HELPER FUNCTIONS
      // ============================================================

      const formatTaxExemption = (taxScheme, principalAmt) => {
        if (!taxScheme || !taxScheme.isExempted) return '';

        const description = taxScheme.description || '';
        const rate = parseFloat(taxScheme.taxRate || 0) / 100;
        const exemptedAmount = rate * principalAmt;

        return `${description} (${amtStr(exemptedAmount.toFixed(2))})`;
      };

      const formatTaxSchemeWithRate = (taxScheme, taxRate) => {
        if (!taxScheme) return '';

        const schemeName = taxScheme.name || '';
        const rate = parseFloat(taxRate || 0) * 100; // Convert decimal to percentage

        return `${schemeName} (${amtStr(rate)}%)`;
      };

      // ============================================================
      // SST ENHANCEMENT - DAYWORKS CALCULATIONS
      // ============================================================

      const dayworkAlloc = previewDetail?.contractClaimMosDayworkAllocation?.find(
        item => item.isDaywork === true,
      );

      let dayworksTransaction = 0;
      let dayworksTaxExempt = '';
      let dayworksTaxScheme = '';
      let dayworksItemTaxAmt = 0;

      if (dayworkAlloc) {
        // Transaction Amount = currentDayWorkAmt (already calculated above)
        dayworksTransaction = currentDayWorkAmt;

        // Tax information from contractClaimMosDayworkAllocationTax array
        const dayworkTax =
          dayworkAlloc.contractClaimMosDayworkAllocationTax?.[0];

        if (dayworkTax) {
          const taxSchemeData = dayworkTax.taxScheme;
          const taxRate = dayworkTax.taxRate || 0;
          const taxAmount = dayworkTax.taxAmount || 0;

          // Tax Scheme with rate
          dayworksTaxScheme = formatTaxSchemeWithRate(taxSchemeData, taxRate);

          // Tax Amount
          dayworksItemTaxAmt = taxAmount;

          // Tax Exemption (only if exempted)
          if (taxSchemeData?.isExclusive) {
            dayworksTaxExempt = formatTaxExemption(
              taxSchemeData,
              currentDayWorkAmt,
            );
          }
        }
      }

      // ============================================================
      // SST ENHANCEMENT - PROGRESS BILLING CALCULATIONS
      // ============================================================

      const progressAllocs = previewDetail?.contractClaimAllocation || [];

      // Progress Billing Item - array of revenue categories
      // const progressBillingItems = progressAllocs.map(alloc => {
      //   const revenueCategoryName = alloc.revenueCategory?.name || '';
      //   return revenueCategoryName;
      // });

      // const progBillingTransactions = progressAllocs.map(alloc => {
      //   // Transaction Amount - use submitted or current based on status
      //   const allocAmt = parseFloat(
      //     previewDetail?.transactionStatus === 'APPROVED'
      //       ? alloc.currentCertifiedAmt
      //       : alloc.submittedCertifiedAmt || '0',
      //   );
      //   return amtStr(allocAmt);
      // });

      let progBillingTransactionTotal = 0;
      let progBillingTotalTaxAmt = 0;
      let progBillingTaxExemptions = [];
      let progBillingTaxSchemes = [];

      progressAllocs.forEach(alloc => {
        const allocAmt = parseFloat(
          previewDetail?.transactionStatus === 'APPROVED'
            ? alloc.currentCertifiedAmt
            : alloc.submittedCertifiedAmt || '0',
        );

        progBillingTransactionTotal += allocAmt;

        // Tax information from contractClaimAllocationTax array
        const allocTax = alloc.contractClaimAllocationTax?.[0];

        if (allocTax) {
          const taxSchemeData = allocTax.taxScheme;
          const taxRate = allocTax.taxRate || 0;
          const taxAmount = allocTax.taxAmount || 0;

          progBillingTotalTaxAmt += taxAmount;

          // Tax Scheme with rate
          const taxSchemeFormatted = formatTaxSchemeWithRate(
            taxSchemeData,
            taxRate,
          );
          if (
            taxSchemeFormatted &&
            !progBillingTaxSchemes.includes(taxSchemeFormatted)
          ) {
            progBillingTaxSchemes.push(taxSchemeFormatted);
          }

          // Tax Exemption (only if exempted)
          if (taxSchemeData?.isExempted) {
            const exemption = formatTaxExemption(taxSchemeData, allocAmt);
            if (exemption) {
              progBillingTaxExemptions.push(exemption);
            }
          }
        }
      });

      const progBillingTaxExempt = progBillingTaxExemptions.join('<br>');
      // const progressBillingTaxScheme = progBillingTaxSchemes.join('<br>');
      const progBillingItemTaxAmt = progBillingTotalTaxAmt;

      // ============================================================
      // SST ENHANCEMENT - MATERIAL ON SITE (MOS) CALCULATIONS
      // ============================================================

      const mosAlloc = previewDetail?.contractClaimMosDayworkAllocation?.find(
        item => item.isMos === true,
      );

      let mosTransaction = 0;
      let mosTaxExempt = '';
      let mosTaxScheme = '';
      let mosItemTaxAmt = 0;

      if (mosAlloc) {
        // Transaction Amount = submittedMosAmt (already calculated above)
        mosTransaction = submittedMosAmt;

        // Tax information from contractClaimMosDayworkAllocationTax array
        const mosTax = mosAlloc.contractClaimMosDayworkAllocationTax?.[0];

        if (mosTax) {
          const taxSchemeData = mosTax.taxScheme;
          const taxRate = mosTax.taxRate || 0;
          const taxAmount = mosTax.taxAmount || 0;

          // Tax Scheme with rate
          mosTaxScheme = formatTaxSchemeWithRate(taxSchemeData, taxRate);

          // Tax Amount
          mosItemTaxAmt = taxAmount;

          // Tax Exemption (only if exempted)
          if (taxSchemeData?.isExempted) {
            mosTaxExempt = formatTaxExemption(taxSchemeData, submittedMosAmt);
          }
        }
      }

      // ============================================================
      // SST ENHANCEMENT - TOTAL TAX CALCULATIONS
      // ============================================================

      // Total Tax Exemption Amount
      let totalTaxExemptedAmt = 0;

      // Sum all exempted amounts from all allocations
      [...progressAllocs].forEach(alloc => {
        const allocTax = alloc.contractClaimAllocationTax?.[0];
        if (allocTax?.taxScheme?.isExempted) {
          const allocAmt = parseFloat(
            previewDetail?.transactionStatus === 'APPROVED'
              ? alloc.currentCertifiedAmt
              : alloc.submittedCertifiedAmt || '0',
          );
          const rate = parseFloat(allocTax.taxRate || 0);
          totalTaxExemptedAmt += rate * allocAmt;
        }
      });

      // Add daywork exemption
      if (dayworkAlloc) {
        const dayworkTax =
          dayworkAlloc.contractClaimMosDayworkAllocationTax?.[0];
        if (dayworkTax?.taxScheme?.isExempted) {
          const rate = parseFloat(dayworkTax.taxRate || 0);
          totalTaxExemptedAmt += rate * currentDayWorkAmt;
        }
      }

      // Add MOS exemption
      if (mosAlloc) {
        const mosTax = mosAlloc.contractClaimMosDayworkAllocationTax?.[0];
        if (mosTax?.taxScheme?.isExempted) {
          const rate = parseFloat(mosTax.taxRate || 0);
          totalTaxExemptedAmt += rate * submittedMosAmt;
        }
      }

      // Total Tax Amount - sum of all tax amounts
      const totalTaxAmt =
        dayworksItemTaxAmt + progBillingItemTaxAmt + mosItemTaxAmt;

      // ============================================================
      // SST ENHANCEMENT - E-INVOICE VALIDATION DATE
      // ============================================================

      const withB2BNote = (value: string) => {
        if (!value || value.trim() === '') return '';
        return `<br><span style="font-size:9pt;color:#666;font-style:italic;">*B2B Exemption</span> ${value}`;
      };

      const grouped: any = Object.values(
        (progressAllocs || [])?.reduce((acc, el) => {
          const key = el?.revenueCategoryID;

          if (!acc[key]) {
            acc[key] = {
              name: el?.revenueCategory?.name || '',
              taxSchemes: new Set<string>(),
              taxAmt: 0,
              retention: 0,
              transaction: 0,
            };
          }

          const tax = el?.contractClaimAllocationTax?.[0];

          // collect unique tax schemes
          const scheme = formatTaxSchemeWithRate(tax?.taxScheme, tax?.taxRate);
          if (scheme) {
            acc[key].taxSchemes.add(scheme);
          }

          // sum tax amount
          acc[key].taxAmt += parseFloat(tax?.taxAmount || 0);

          // sum retention
          acc[key].retention += parseFloat(el?.currentRetentionAmt || 0);

          acc[key].transaction += parseFloat(
            previewDetail?.transactionStatus === 'APPROVED'
              ? el?.currentCertifiedAmt
              : el?.submittedCertifiedAmt || 0,
          );

          return acc;
        }, {} as Record<string, any>),
      );

      Object.assign(paramVal, debtorDetails, {
        // ───── BASIC ─────
        '[remark]': previewDetail?.remark ?? '',
        '[description]': previewDetail?.description ?? '',
        '[claimDocNo]': previewDetail?.claimDocNo ?? '',
        '[paymentFor]': previewDetail?.description ?? '',

        // ───── PAYMENT ─────
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ───── AMOUNTS ─────
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',
        '[progressBillingToDate]': amtStr(progressBillingToDate.toString()),
        '[totalAmtInWords]': moneyFunction(totalPayableAmt.toString()),

        '[totalClaimAmt]': amtStr(sumOfClaim),
        '[totalPayableAmt]': amtStr(totalPayableAmt.toString()),

        '[subtotalAmt]': amtStr(previewDetail?.baseAmt),
        '[retentionReceivable]': amtStr(previewDetail?.retentionAmt),
        '[itemTaxAmt]': amtStr(taxAmt),
        '[itemTotalAmt]': amtStr(itemTotalAmt),

        // ───── CONTRACT INFO ─────
        '[contractNo]': previewDetail?.contract?.contractNo ?? '',
        '[contractSum]': amtStr(previewDetail?.contract?.contractSum),
        '[voAmount]': amtStr(previewDetail?.voDisplayAmt),
        '[revisedContractSum]': amtStr(
          previewDetail?.contract?.revisedContractSum,
        ),
        '[maxRetentionSum]': amtStr(previewDetail?.contract?.maxRetentionSum),

        // ───── DOCUMENT INFO ─────
        '[claimNo]': previewDetail?.claimNo ?? previewDetail?.claimDocNo ?? '',
        '[docNo]': previewDetail?.docNo ?? '',
        '[docRefNo]': previewDetail?.docRef ?? '',
        '[preparedBy]': previewDetail?.preparedBy ?? '',

        // ───── DATES ─────
        '[docDate]': dateFormat(previewDetail?.contract?.startDate),
        '[docDueDate]': dateFormat(previewDetail?.contract?.endDate),
        '[submittedDate]': dateFormat(previewDetail?.submittedDate),
        '[approvalDate]': dateFormat(previewDetail?.docDate),

        // ───── CLAIM COMPONENTS ─────
        '[currentApprovalAmt]': amtStr(previewDetail?.submittedCertifiedAmt),
        '[voClaimAmt]': amtStr(previewDetail?.currentVOClaimAmt),
        '[totalClaimApprovalAmt]': amtStr(totalClaimAmt.toString()),
        '[currentMosAmt]': amtStr(previewDetail?.submittedMosAmt),
        '[materialOnSiteAmt]': amtStr(previewDetail?.submittedMosAmt),
        '[previousMosAmt]': amtStr(previewDetail?.previousMosAmt),
        '[previousCertifiedAmt]': amtStr(previewDetail?.previousCertifiedAmt),
        '[previousVOClaimAmt]': amtStr(previewDetail?.previousVOClaimAmt),
        '[dayworksAmt]': amtStr(previewDetail?.currentDayWorkAmt),
        '[currentDeductionAmt]': amtStr(previewDetail?.currentDeductionAmt),
        '[advanceRecoupmentAmt]': amtStr(previewDetail?.advanceRecoupmentAmt),

        // ───── CURRENCY ─────
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',
        '[noteText]': previewDetail?.noteText ?? '',

        // ============================================================
        // SST ENHANCEMENT - NEW PARAMETERS
        // ============================================================

        // ───── DAYWORKS ─────
        '[dayworksTransaction]': amtStr(dayworksTransaction),
        '[dayworksTaxExempt]': withB2BNote(dayworksTaxExempt),
        '[dayworksTaxScheme]': dayworksTaxScheme,
        '[dayworksItemTaxAmt]': amtStr(dayworksItemTaxAmt),

        // ───── PROGRESS BILLING ─────
        // '[progressBillingItem]': progressBillingItems.join('<br>'), // For row duplication
        // '[progBillingTransaction]': progBillingTransactions.join('<br>'),
        '[progBillingTaxExempt]': withB2BNote(progBillingTaxExempt),
        // '[progressBillingTaxScheme]': progressBillingTaxScheme,
        // '[progBillingItemTaxAmt]': amtStr(progBillingItemTaxAmt),

        // ───── MATERIAL ON SITE ─────
        '[mosTransaction]': amtStr(mosTransaction),
        '[mosTaxExempt]': withB2BNote(mosTaxExempt),
        '[mosTaxScheme]': mosTaxScheme,
        '[mosItemTaxAmt]': amtStr(mosItemTaxAmt),

        // ───── TOTALS ─────
        '[totalTaxExemptedAmt]': amtStr(totalTaxExemptedAmt.toFixed(2)),
        '[totalTaxAmt]': amtStr(totalTaxAmt.toFixed(2)),

        // ───── E-INVOICE ─────
        '[dateandTimeofValidation]': previewDetail?.eInvoiceValidationDate
          ? formatDateAndTime(previewDetail?.eInvoiceInfo?.submittedDate)
          : '',

        '[progBillingItem]': grouped?.map(g => g?.name).join('<br>'),

        '[progBillingTaxScheme]': grouped
          ?.map(g => Array.from(g?.taxSchemes))
          .join('<br>'),

        '[progBillingItemTaxAmt]': grouped
          ?.map(g => {
            const val = g?.taxAmt === 0 ? '0.00' : amtStr(g?.taxAmt);
            return val || '0.00';
          })
          .join('<br>'),

        '[progBillingRetention]': grouped
          ?.map(g => {
            const val = g?.retention === 0 ? '0.00' : amtStr(g?.retention);
            return val || '0.00';
          })
          .join('<br>'),

        '[progBillingTransaction]': grouped
          ?.map(g => {
            const val = g?.transaction === 0 ? '0.00' : amtStr(g?.transaction);
            return val || '0.00';
          })
          .join('<br>'),
      });
      break;
    }

    /* -------------------------------------------------
     * 9. CLAIM WORKDONE
     * -------------------------------------------------*/
    case 'claim-workdone': {
      // ─── TYPES ─────────────────────────────────────────────
      type WBSItem = {
        ID: string;
        wsID?: string;
        name: string;
        sequence?: number;
        claimWBS?: {
          awardedAmt: number;
          previousCertifiedAmt: number;
          submittedCertifiedAmt: number;
          currentCertifiedAmt: number;
          netSubmittedAmt: number;
          netCurrentAmt: number;
          sequence?: number;
        };
        claimVOWBS?: Array<{
          docNo: string;
          awardedAmt: number;
          previousVOClaimAmt: number;
          submittedVOClaimAmt: number;
          currentVOClaimAmt: number;
          netSubmittedVOAmt: number;
          netCurrentVOAmt: number;
        }>;
      };

      type GroupedItem = {
        name: string;
        sequence?: number;
        status?: string;
        claimWBS?: WBSItem['claimWBS'];
        claimVOWBS: WBSItem['claimVOWBS'];
      };

      // ─── GROUPING & SORTING ────────────────────────────────
      const groupedItems: Record<string, GroupedItem> = {};

      (previewDetail?.claimDetailRevenueWBS as WBSItem[])?.forEach(wbs => {
        const groupKey = wbs.wsID || wbs.ID;
        if (!groupKey) return;

        if (!groupedItems[groupKey]) {
          groupedItems[groupKey] = {
            name: wbs.name,
            sequence: wbs.sequence ?? wbs.claimWBS?.sequence ?? 0,
            status: previewDetail?.transactionStatus,
            claimWBS: undefined,
            claimVOWBS: [],
          };
        }

        if (wbs.claimWBS) {
          groupedItems[groupKey].claimWBS = wbs.claimWBS;
        }

        if (wbs.claimVOWBS?.length) {
          groupedItems[groupKey].claimVOWBS.push(...wbs.claimVOWBS);
        }
      });

      const sortedGroups = Object.values(groupedItems).sort(
        (a, b) => (a.sequence || 0) - (b.sequence || 0),
      );

      // ─── DISPLAY ITEMS & TOTALS ────────────────────────────
      const displayItems = [];
      const grandTotals = {
        awardedAmt: 0,
        previousAmt: 0,
        currentAmt: 0,
        netAmt: 0,
      };

      sortedGroups.forEach(group => {
        const groupItems = [];
        const groupSubtotal = {
          awardedAmt: 0,
          previousAmt: 0,
          currentAmt: 0,
          netAmt: 0,
        };

        if (group.claimWBS) {
          const wbsItem = {
            type: 'work',
            name: group.name,
            awardedAmt: group.claimWBS.awardedAmt || 0,
            previousAmt: group.claimWBS.previousCertifiedAmt || 0,
            currentAmt:
              (group.status === 'APPROVED'
                ? group.claimWBS.currentCertifiedAmt
                : group.claimWBS.submittedCertifiedAmt) || 0,
            netAmt:
              (group.status === 'APPROVED'
                ? group.claimWBS.netCurrentAmt
                : group.claimWBS.netSubmittedAmt) || 0,
          };
          groupItems.push(wbsItem);

          groupSubtotal.awardedAmt += wbsItem.awardedAmt;
          groupSubtotal.previousAmt += wbsItem.previousAmt;
          groupSubtotal.currentAmt += wbsItem.currentAmt;
          groupSubtotal.netAmt += wbsItem.netAmt;
        }

        group.claimVOWBS?.forEach(vo => {
          const voItem = {
            type: 'vo',
            name: vo.docNo || 'VO Item',
            awardedAmt: vo.awardedAmt || 0,
            previousAmt: vo.previousVOClaimAmt || 0,
            currentAmt:
              (group.status === 'APPROVED'
                ? vo.currentVOClaimAmt
                : vo.submittedVOClaimAmt) || 0,
            netAmt:
              (group.status === 'APPROVED'
                ? vo.netCurrentVOAmt
                : vo.netSubmittedVOAmt) || 0,
          };
          groupItems.push(voItem);

          groupSubtotal.awardedAmt += voItem.awardedAmt;
          groupSubtotal.previousAmt += voItem.previousAmt;
          groupSubtotal.currentAmt += voItem.currentAmt;
          groupSubtotal.netAmt += voItem.netAmt;
        });

        if (groupItems.length) {
          displayItems.push(...groupItems);
          displayItems.push({
            type: 'subtotal',
            name: 'Subtotal',
            ...groupSubtotal,
          });

          grandTotals.awardedAmt += groupSubtotal.awardedAmt;
          grandTotals.previousAmt += groupSubtotal.previousAmt;
          grandTotals.currentAmt += groupSubtotal.currentAmt;
          grandTotals.netAmt += groupSubtotal.netAmt;
        }
      });

      // ─── PARAM ASSIGN ──────────────────────────────────────
      Object.assign(paramVal, debtorDetails, {
        // ─── General Info ───
        '[remark]': previewDetail?.remark ?? '',
        '[claimDocNo]': previewDetail?.claimDocNo ?? '',
        '[paymentFor]': previewDetail?.description ?? '',
        '[bankCode]': previewDetail?.bankDetails?.code ?? '',
        '[bankAccNo]': previewDetail?.bankDetails?.accountNo ?? '',
        '[paymentMethod]': previewDetail?.paymentMethod?.Name ?? '',
        '[chequeNo]': previewDetail?.chequeNo ?? '',

        // ─── Amounts ───
        '[docAmt]': amtStr(previewDetail?.docAmt) ?? '',
        '[principalAmt]': amtStr(previewDetail?.localBaseAmt) ?? '',
        '[taxRate]':
          previewDetail?.taxRate !== undefined
            ? `${amtStr(previewDetail.taxRate)}%`
            : '',
        '[taxAmt]': amtStr(previewDetail?.taxAmt) ?? '',

        // ─── Currency ───
        '[companyCurrencyCode]':
          previewDetail?.user?.companyCurrencyCode ??
          companyDetails?.currencyCode ??
          '',
        '[currency]': companyDetails?.currency ?? '',

        // ─── Work Items ───
        items: displayItems.map((item, i) => ({
          '[index]': i + 1,
          '[workItemDesc]': item.name,
          '[awardedAmt]': amtStr(item.awardedAmt),
          '[previousAmt]': amtStr(item.previousAmt),
          '[currentAmt]': amtStr(item.currentAmt),
          '[netAmt]': amtStr(item.netAmt),
          '[isVO]': item.type === 'vo',
          '[isSubtotal]': item.type === 'subtotal',
          '[subtotalAwardedAmt]':
            item.type === 'subtotal' ? amtStr(item.awardedAmt) : '',
          '[subtotalPreviousAmt]':
            item.type === 'subtotal' ? amtStr(item.previousAmt) : '',
          '[subtotalCurrentAmt]':
            item.type === 'subtotal' ? amtStr(item.currentAmt) : '',
          '[subtotalNetAmt]':
            item.type === 'subtotal' ? amtStr(item.netAmt) : '',
        })),

        // ─── Totals ───
        '[totalApprovalAmt]': amtStr(grandTotals.awardedAmt.toFixed(2)),
        '[totalPreviousAmt]': amtStr(grandTotals.previousAmt.toFixed(2)),
        '[totalCurrentAmt]': amtStr(grandTotals.currentAmt.toFixed(2)),
        '[totalNetAmt]': amtStr(grandTotals.netAmt.toFixed(2)),
        '[totalAmtInWords]': moneyFunction(grandTotals.netAmt),

        // ─── Contract & Dates ───
        '[docDate]': dateFormat(previewDetail?.contract?.startDate),
        '[docDueDate]': dateFormat(previewDetail?.contract?.endDate),
        '[contractSum]': amtStr(previewDetail?.contract?.contractSum),
        '[voAmount]': amtStr(previewDetail?.voDisplayAmt),
        '[revisedContractSum]': amtStr(
          previewDetail?.contract?.revisedContractSum,
        ),
        '[maxRetentionSum]': amtStr(previewDetail?.contract?.maxRetentionSum),
        '[contractNo]': previewDetail?.contract?.contractNo ?? '',
        '[claimNo]': previewDetail?.claimNo ?? previewDetail?.claimDocNo ?? '',
        '[docNo]': previewDetail?.docNo ?? '',
        '[submissionDate]': dateFormat(previewDetail?.submittedDate),
        '[approvalDate]': dateFormat(previewDetail?.docDate),
        '[docRefNo]': previewDetail?.docRef ?? '',
        '[noteText]': previewDetail?.noteText ?? '',
      });
      break;
    }
  }
};
